/* agent-knowledge-card.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./agent-knowledge-card.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { AgentProfileCardTrigger } from '@atlaskit/profilecard';
import { AgentAvatar } from '@atlaskit/rovo-agent-components';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { useAnalytics } from '../../common/controller/analytics';
import { QueryIntent } from '../../constants';
import { KnowledgeCarousel } from '../../knowledge-card-components';
import { useMeaningfulHover } from '../../v2/common/hooks/use-meaningful-hover';
import { AIDisclaimerAndFeedback } from '../../v2/common/ui/ai-disclaimer-and-feedback';
import { onAgentKnowledgeCardCarouselItemClick, onAgentKnowledgeCardCarouselShown, onIndividualAgentKnowledgeCardShown, onKnowledgeCardShown } from '../analytics';
import { KnowledgeCardLoading } from '../knowledge-card-loading';
import { SeparatorLineRefresh } from '../separator-line';
import { KnowledgeCardsIntentType } from '../types';
import { createProfileClient, getAgentProfileUrl } from '../util';
import { AgentCardBody } from './agent-card-body';
import { AgentCardHeader } from './agent-card-header';
import { useAgentCardData } from './use-agent-card-data';
var CardContainerStyles = {
  refresh: "_2rko12b0 _zulppxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _ca0qpxbi _n3tdpxbi",
  disclaimer: "_19bvpxbi _u5f3pxbi"
};
var AgentCardWrapperStyles = {
  wrapper: "_2rko1mok _v564nm7n _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _i0dlmgvx _16jlidpf _1o9zidpf _1bsbmgvx _1ul91lit _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _kqswh2mm _o5724jg8 _9oik1r31 _1bnxglyw _jf4cnqa1 _d0altlke _1s5z1k61 _le1b1cqc _73vx1ytf _1gav5cps"
};
var AGENTS_SCROLL_OFFSET = 392;
var messages = defineMessages({
  multiple_agents_matches_header: {
    id: 'search_ai.knowledge_cards.multiple_agents_matches_header',
    defaultMessage: 'Agent matches',
    description: 'Header for the multiple agents carousel'
  }
});
var IndividualAgentKnowledgeCard = function IndividualAgentKnowledgeCard(_ref) {
  var _teamsData$teamSearch;
  var agent = _ref.agent;
  var _useAgentCardData = useAgentCardData(agent),
    teamsData = _useAgentCardData.teamsData,
    activityData = _useAgentCardData.activityData,
    loading = _useAgentCardData.loading;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var orgId = commonAttributes.orgId;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];

  // Fire analytics event when individual agent knowledge card is shown
  React.useEffect(function () {
    if (agent) {
      fireAnalyticsEvent(onIndividualAgentKnowledgeCardShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        agentId: agent.id
      })));
    }
  }, [agent, commonAttributes, fireAnalyticsEvent]);
  if (!agent) {
    return null;
  }
  if (loading) {
    return /*#__PURE__*/React.createElement(KnowledgeCardLoading, {
      queryIntent: QueryIntent.AGENT
    });
  }
  var showKnowledgeCardBody = (teamsData === null || teamsData === void 0 || (_teamsData$teamSearch = teamsData.teamSearch) === null || _teamsData$teamSearch === void 0 ? void 0 : _teamsData$teamSearch.nodes) && teamsData.teamSearch.nodes.length > 0 || activityData && Array.isArray(activityData) && activityData.length > 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    xcss: CardContainerStyles.refresh
  }, /*#__PURE__*/React.createElement(AgentCardHeader, {
    agent: agent
  }), showKnowledgeCardBody && /*#__PURE__*/React.createElement(SeparatorLineRefresh, null), /*#__PURE__*/React.createElement(Box, null, showKnowledgeCardBody && /*#__PURE__*/React.createElement(AgentCardBody, {
    currentUserId: agent.identity_account_id || '',
    teamsData: teamsData,
    activityData: activityData,
    profileUrl: getAgentProfileUrl(agent, orgId)
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: CardContainerStyles.disclaimer
  }, /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
    showFeedbackButtons: true
  })))));
};
export var AgentKnowledgeCard = function AgentKnowledgeCard(_ref2) {
  var onFMPReached = _ref2.onFMPReached;
  var _useAIAnswerContext2 = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext2.commonAttributes,
    loading = _useAIAnswerContext2.loading,
    userDetails = _useAIAnswerContext2.userDetails;
  var cloudId = commonAttributes.cloudId;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAnalytics3 = useAnalytics(),
    _useAnalytics4 = _slicedToArray(_useAnalytics3, 1),
    fireAnalyticsEvent = _useAnalytics4[0];
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedAgent = _useState2[0],
    setSelectedAgent = _useState2[1];
  var answerString = commonAttributes.answerString;

  // Parses the answerString to extract agent results, returning an empty array if parsing fails or if the result is not an array.
  var agentResults = useMemo(function () {
    if (!answerString) {
      return [];
    }
    try {
      var parsed = JSON.parse(answerString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_unused) {
      return [];
    }
  }, [answerString]);

  // Fire analytics event when carousel is shown (only when multiple agents exist)
  React.useEffect(function () {
    if (agentResults && agentResults.length > 1) {
      fireAnalyticsEvent(onAgentKnowledgeCardCarouselShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        agentCount: agentResults.length
      })));
    }
  }, [agentResults, commonAttributes, fireAnalyticsEvent]);
  var profileClient = useMemo(function () {
    return createProfileClient(cloudId);
  }, [cloudId]);
  var getHandleSelectAgent = useCallback(function (index) {
    return function () {
      var selectedAgentData = agentResults[index];
      setSelectedAgent(selectedAgentData);

      // Fire analytics event for carousel item click
      fireAnalyticsEvent(onAgentKnowledgeCardCarouselItemClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        agentId: selectedAgentData.id,
        position: index
      })));
    };
  }, [agentResults, commonAttributes, fireAnalyticsEvent]);
  useEffect(function () {
    if (agentResults.length === 1) {
      setSelectedAgent(agentResults[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agentResults]);
  useEffect(function () {
    onFMPReached === null || onFMPReached === void 0 || onFMPReached();
    fireAnalyticsEvent(onKnowledgeCardShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      cardType: KnowledgeCardsIntentType.AGENT
    })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var _useMeaningfulHover = useMeaningfulHover({
      elementType: 'agent',
      hoverCardSelector: '[data-testid="agent-knowledge-card-trigger"]'
    }),
    handleHoverStart = _useMeaningfulHover.handleHoverStart,
    handleHoverLeave = _useMeaningfulHover.handleHoverLeave;
  if (loading) {
    return /*#__PURE__*/React.createElement(KnowledgeCardLoading, null);
  }
  if (agentResults.length === 0) {
    return null;
  }
  if (selectedAgent !== undefined || agentResults.length === 1) {
    return /*#__PURE__*/React.createElement(IndividualAgentKnowledgeCard, {
      agent: selectedAgent
    });
  }
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.150"
  }, /*#__PURE__*/React.createElement(KnowledgeCarousel, {
    heading: formatMessage(messages.multiple_agents_matches_header),
    scrollOffset: AGENTS_SCROLL_OFFSET
  }, agentResults.map(function (agent, index) {
    return /*#__PURE__*/React.createElement(Box, {
      onClick: getHandleSelectAgent(index),
      testId: "agent-knowledge-card-wrapper",
      key: agent.id,
      xcss: AgentCardWrapperStyles.wrapper,
      onMouseEnter: handleHoverStart,
      onMouseLeave: handleHoverLeave
    }, /*#__PURE__*/React.createElement(AgentProfileCardTrigger, {
      trigger: "hover",
      agentId: agent.id,
      resourceClient: profileClient,
      cloudId: cloudId,
      viewingUserId: userDetails.id,
      testId: "agent-knowledge-card-trigger"
    }, /*#__PURE__*/React.createElement(Stack, {
      space: "space.150",
      alignInline: "center"
    }, /*#__PURE__*/React.createElement(AgentAvatar, {
      agentId: agent.id,
      agentNamedId: agent.id,
      agentIdentityAccountId: agent.identity_account_id,
      size: "xxlarge"
    }), /*#__PURE__*/React.createElement(Stack, {
      space: "space.100",
      alignInline: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      maxLines: 1,
      size: "medium",
      weight: "medium",
      align: "center"
    }, agent.name), agent.description && /*#__PURE__*/React.createElement(Text, {
      maxLines: 1,
      size: "medium",
      color: "color.text.subtlest",
      align: "center"
    }, agent.description)))));
  })), /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
    showFeedbackButtons: true
  }));
};